import React from 'react';

export const PageScrollContext =
    React.createContext<React.RefObject<HTMLDivElement> | null>(null);

export function usePageScroll(): {
    scrollTo: (options: ScrollToOptions) => void;
} {
    const scrollContainerRef = React.useContext(PageScrollContext);
    const scrollTo = React.useCallback(
        (options: ScrollToOptions) => {
            // Reports also render outside Page, where the window owns scrolling.
            const target = scrollContainerRef?.current ?? window;
            target.scrollTo(options);
        },
        [scrollContainerRef]
    );

    return { scrollTo };
}
